import { createApp } from 'vue';
import DateOfBirthInput from '../../common/component/DateOfBirthInput.vue';

document.addEventListener('DOMContentLoaded', () => {
  const propsDataEl = document.getElementById('profile-props-data');
  const propsData = JSON.parse(propsDataEl.dataset.propsData);
  const app = createApp(DateOfBirthInput, propsData);
  app.mount('#date-of-birth-date-picker');
});
